(function () {
  if (window.CleerdentShopMenu) return;

  var DESKTOP_BREAKPOINT = 1025;
  var root = null;
  var activeTrigger = null;
  var isMobileSession = false;
  var returnToMobileDrawer = false;

  function queryRoot() {
    return document.querySelector("[data-cd-shop-menu]");
  }

  function isMobile() {
    return window.innerWidth < DESKTOP_BREAKPOINT;
  }

  function getActivePanel() {
    if (!root) return null;
    return isMobile()
      ? root.querySelector("[data-cd-shop-mobile]")
      : root.querySelector("[data-cd-shop-desktop]");
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      )
      .filter(function (node) {
        return !node.hidden && node.getClientRects().length > 0;
      });
  }

  function setTriggerExpanded(expanded) {
    document
      .querySelectorAll("[data-cd-shop-trigger]")
      .forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
  }

  function updateTop() {
    if (!root || isMobile()) {
      if (root) root.style.setProperty("--cd-shop-menu-top", "0px");
      return;
    }

    var headerSection =
      document.querySelector(".t4s-section-header") ||
      document.querySelector("[data-cd-hero-header]");
    var headerBottom = headerSection
      ? Math.max(0, headerSection.getBoundingClientRect().bottom)
      : parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue(
            "--cd-home-header-height",
          ),
        ) || 80;

    root.style.setProperty(
      "--cd-shop-menu-top",
      Math.round(headerBottom) + "px",
    );
  }

  function showMobileView(viewName, focusHeading) {
    if (!root) return;
    var views = root.querySelectorAll("[data-cd-shop-view]");
    var target = null;

    views.forEach(function (view) {
      var active = view.getAttribute("data-cd-shop-view") === viewName;
      view.classList.toggle("is-active", active);
      view.hidden = !active;
      if (active) target = view;
    });

    if (focusHeading && target) {
      var focusTarget =
        target.querySelector("[data-cd-shop-back]") ||
        target.querySelector(".cd-shop-menu__mobile-title");
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }
  }

  function openMenu(trigger) {
    root = root || queryRoot();
    if (!root) return;

    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    activeTrigger = trigger || document.activeElement;
    isMobileSession =
      isMobile() ||
      Boolean(trigger && trigger.hasAttribute("data-cd-shop-trigger-mobile"));
    var requestedView =
      (trigger && trigger.getAttribute("data-cd-shop-open-category")) ||
      "root";
    returnToMobileDrawer = isMobileSession && requestedView !== "root";

    updateTop();
    showMobileView(requestedView, false);
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cd-shop-menu-open");
    document.body.classList.add("cd-shop-menu-open");
    setTriggerExpanded(true);

    window.requestAnimationFrame(function () {
      var panel = getActivePanel();
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  function closeUnderlyingMobileDrawer() {
    var drawer = document.querySelector("#t4s-menu-drawer");
    if (!drawer || drawer.getAttribute("aria-hidden") === "true") return;

    var closeButton = document.querySelector(".t4s-drawer-menu__close");
    if (closeButton) {
      closeButton.click();
      return;
    }

    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("t4s-drawer-menu__opened");
  }

  function closeMenu(options) {
    if (!root || !root.classList.contains("is-open")) return;
    var closeDrawer = Boolean(options && options.closeDrawer);
    var restoreFocus = !options || options.restoreFocus !== false;

    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cd-shop-menu-open");
    document.body.classList.remove("cd-shop-menu-open");
    setTriggerExpanded(false);
    showMobileView("root", false);

    if (closeDrawer && isMobileSession) {
      closeUnderlyingMobileDrawer();
    }

    if (
      restoreFocus &&
      activeTrigger &&
      document.documentElement.contains(activeTrigger)
    ) {
      activeTrigger.focus({ preventScroll: true });
    }

    activeTrigger = null;
    isMobileSession = false;
    returnToMobileDrawer = false;
  }

  function onClick(event) {
    var trigger = event.target.closest("[data-cd-shop-trigger]");
    if (trigger) {
      root = root || queryRoot();
      if (!root) return;
      event.preventDefault();
      if (root.classList.contains("is-open")) {
        closeMenu();
      } else {
        openMenu(trigger);
      }
      return;
    }

    if (!root || !root.classList.contains("is-open")) return;

    var mobileCart = event.target.closest(".cd-shop-menu__mobile-cart");
    if (mobileCart && root.contains(mobileCart)) {
      closeMenu({ closeDrawer: true, restoreFocus: false });
      return;
    }

    var categoryButton = event.target.closest("[data-cd-shop-category]");
    if (categoryButton && root.contains(categoryButton)) {
      event.preventDefault();
      showMobileView(categoryButton.getAttribute("data-cd-shop-category"), true);
      return;
    }

    var backButton = event.target.closest("[data-cd-shop-back]");
    if (backButton && root.contains(backButton)) {
      event.preventDefault();
      if (returnToMobileDrawer) {
        closeMenu();
      } else {
        showMobileView("root", true);
      }
      return;
    }

    var closeButton = event.target.closest("[data-cd-shop-close]");
    if (closeButton && root.contains(closeButton)) {
      event.preventDefault();
      closeMenu({
        closeDrawer: closeButton.hasAttribute("data-cd-shop-close-drawer"),
        restoreFocus: !closeButton.hasAttribute("data-cd-shop-close-drawer"),
      });
    }
  }

  function onKeydown(event) {
    if (!root || !root.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      event.preventDefault();
      var activeView = root.querySelector(
        '[data-cd-shop-view].is-active:not([data-cd-shop-view="root"])',
      );
      if (isMobile() && activeView) {
        if (returnToMobileDrawer) {
          closeMenu();
        } else {
          showMobileView("root", true);
        }
      } else {
        closeMenu();
      }
      return;
    }

    if (event.key !== "Tab") return;
    var focusable = getFocusable(getActivePanel());
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onResize() {
    if (!root || !root.classList.contains("is-open")) return;
    updateTop();
  }

  function init() {
    root = queryRoot();
    if (!root) return;
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKeydown);
    window.addEventListener("resize", onResize, { passive: true });
  }

  window.CleerdentShopMenu = {
    open: openMenu,
    close: closeMenu,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
